import { PlatformContext } from "contexts";
import { useContext } from "react";
import { EventNames, sendGTMEvent } from "utils/gtm";

export const useGoogleAnalytics = () => {
  const { getLoggedIn, getUser } = useContext(PlatformContext);

  const sendPageViewEvent = (pageTitle: string, pageUrl: string) => {
    sendGTMEvent({
      event: EventNames.PAGE_VIEW,
      title: pageTitle || document.title,
      url: pageUrl || window.location.href,
      timestamp: new Date().toISOString()
    });
  };
  
  const sendEvent = (event: string, payload: any) => {
    const user = getUser();
    const isLoggedIn = getLoggedIn();
    sendGTMEvent({
      event,
      isAuthenticated: isLoggedIn,
      userId: user?.id,
      userEmailAddress: user?.email,
      ...payload,
    });
  };

  return {
    sendEvent,
    sendPageViewEvent,
  };
};